module.exports = __webpack_public_path__ + "6f26357579b85fe7e78945a38c673da8.woff";


//////////////////
// WEBPACK FOOTER
// ./src/public/fonts/Work_Sans/WorkSans-Medium.woff
// module id = 1814
// module chunks = 1